import { useMemo } from 'react';
import Link from './link';
import Header from './header';
import UptimeRobot from './uptimerobot';
import Package from '../../package.json';

function App() {

  const apikeys = useMemo(() => {
    const { ApiKeys } = window.Config;
    if (Array.isArray(ApiKeys)) return ApiKeys;
    if (typeof ApiKeys === 'string') return [ApiKeys];
    return [];
  }, []);

  return (
    <>
      <Header />
      <div className='container'>
        <div id='uptime'>
          {apikeys.map((key) => (
            <UptimeRobot key={key} apikey={key} />
          ))}
        </div>
        <div id='footer'>
          <p>基于&nbsp;<Link to='https://uptimerobot.com/' text='UptimeRobot' />&nbsp;接口&nbsp;|&nbsp;检测频率&nbsp;30&nbsp;分钟</p>
          <p>Copyright&nbsp;&copy;&nbsp;2020&nbsp;-&nbsp;2024&nbsp;<Link to='https://www.linkkk.top/' text='linkkk' />&nbsp;|&nbsp;Powered by&nbsp;<Link to='https://github.com/2319564679/myuptimestatusxiugai' text='uptime-status' />&nbsp;{Package.version}</p>
        <p><a href="http://beian.miit.gov.cn/">粤ICP备2022033866号</a></p>
          </div>
      </div>
    </>
  );
}

export default App;
